import { FC, ReactNode } from 'react';
import './PunchupFormModuleWrapper.css';

export interface PunchupFormModuleWrapperProps {
	children: ReactNode;
	className?: string;
}

/**
 * PunchupFormModuleWrapper
 *
 * Grey bordered section container used to visually isolate a sub-section
 * inside a larger form (e.g. the embedded PunchupImageUpload in the ticket form).
 *
 * Use this whenever a form contains an independently-scoped control group
 * (image upload, tag manager, etc.) that should sit inside its own box,
 * separate from the parent form's Cancel / Save button row.
 */
export const PunchupFormModuleWrapper: FC<PunchupFormModuleWrapperProps> = ({ children, className }) => (
	<div className={['punchupFormModuleWrapper', className].filter(Boolean).join(' ')}>{children}</div>
);
